import _ from "underscore";
import PropTypes from "prop-types";
import React from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";

const { func, string, object, bool } = PropTypes;

export default class extends React.Component {
  static displayName = "OutsideClick";

  static propTypes = {
    element: func,
    closeOnElementClick: bool,
    onOutsideClick: func,
    className: string,
  };

  componentDidMount() {
    // this binds to body to avoid getting in a click bubbling fight with React,
    // which binds to document
    return document.body.addEventListener("click", this.handleOutsideClick);
  }

  componentWillUnmount() {
    return document.body.removeEventListener("click", this.handleOutsideClick);
  }

  handleOutsideClick = evnt => {
    const node = ReactDOM.findDOMNode(this);
    if (node != null) {
      if (!node.contains(evnt.target)) {
        return typeof this.props.onOutsideClick === "function" ? this.props.onOutsideClick(evnt) : undefined;
      } else if (node === evnt.target && this.props.closeOnElementClick) {
        return typeof this.props.onOutsideClick === "function" ? this.props.onOutsideClick(evnt) : undefined;
      }
    }
  };

  render() {
    const base_props = {
      className: classNames("et--outside-click-area", this.props.className),
    };
    const props = _.extend(
      base_props,
      _.omit(this.props, ["element", "className", "onOutsideClick", "closeOnElementClick"])
    );

    return this.props.element ? this.props.element(props) : <div {...props} />;
  }
}
